import { render, staticRenderFns } from "./TradeResultFullVolume.vue?vue&type=template&id=caeae418&scoped=true&"
import script from "./TradeResultFullVolume.vue?vue&type=script&lang=js&"
export * from "./TradeResultFullVolume.vue?vue&type=script&lang=js&"
import style0 from "./TradeResultFullVolume.vue?vue&type=style&index=0&id=caeae418&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caeae418",
  null
  
)

export default component.exports